import ProfileOverviewType from "../types/profile/ProfileOverview"


export const getCurrentCampaignYear = () => {
    return Number(sessionStorage.getItem("activeCampaignYear"))
}

export const getLastYearSubmittedCampaign = (profile: ProfileOverviewType) => {
    const currentYear = getCurrentCampaignYear()
    return profile.previous_campaigns.find((campaign) => campaign.year === currentYear - 1 && (campaign.statusCode === "EXTERNAL_SUBMITTED" || campaign.statusCode === "INTERNAL_IN_PROGRESS"))
}

export const shouldDisplayPreviousYearAttributes = () => {
    const pastYear = String(getCurrentCampaignYear() - 1)
    return sessionStorage.getItem('previousSnapshotData') !== null || sessionStorage.getItem("previousSnapshotDataInternal" + pastYear) !== null
}

export const shouldDisplayPreviousTwoYearAttributes = () => {
    const pastTwoYears = String(getCurrentCampaignYear() - 2)
    return sessionStorage.getItem("previousSnapshotDataInternal" + pastTwoYears) !== null
}

export const accordionDisplay = (isInternal: boolean, type: string) => {
    if (!isInternal || (shouldDisplayPreviousYearAttributes() && !shouldDisplayPreviousTwoYearAttributes()) || (!shouldDisplayPreviousYearAttributes() && shouldDisplayPreviousTwoYearAttributes()) || (!shouldDisplayPreviousYearAttributes() && !shouldDisplayPreviousTwoYearAttributes())) {
        if (type === "right") {
            return "accordion-right-wide"
        } else {
            if (!isInternal || (!shouldDisplayPreviousYearAttributes() && !shouldDisplayPreviousTwoYearAttributes())) {
                return "accordion-extra-wide"
            } else {
                return "accordion-wide"
            }
        }
    } else {
        if (type === "right") {
            return "accordion-right"
        } else {
            return "accordion"
        }
    }
}